import { useState } from "react";
import { dispatch } from "../../state/store";
import { pushCreatedTableRowsIds, setFwuCampaingsRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { fwuCampaignsService, log, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

import { useCreateFWUCampaign } from "./useCreateFWUCampaign";
import { useCreateNotificationCampaign } from "../notificationCampaigns/useCreateNotificationCampaign";
import { useUpdateNotificationCampaign } from "../notificationCampaigns/useUpdateNotificationCampaign";

export const useUpdateFWUCampaign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { mutationCallback: createNotificationCampaign } = useCreateNotificationCampaign();
  const { mutationCallback: updateNotificationCampaign } = useUpdateNotificationCampaign();
  const { handleIncorrectDusns } = useCreateFWUCampaign();

  const onSuccess = (fwuCampaign) => {
    notificationService.showSuccess({
      title: t(strCode.UPDATE_FWU_CAMPAIGN_SUCCESS),
      message: t(strCode.UPDATE_FWU_CAMPAIGN_SUCCESS_INFO, {
        name: fwuCampaign.campaign_name
      })
    });
  };

  const mutationCallback = async (
    fwuCampaign,
    fwNotificationCampaign,
    updateNotification = false
  ) => {
    setLoading(true);
    setError(false);

    try {
      let notificationCampaignRes;

      if (fwNotificationCampaign) {
        notificationCampaignRes = updateNotification
          ? await updateNotificationCampaign(fwNotificationCampaign)
          : await createNotificationCampaign(fwNotificationCampaign);
      }

      const fwuCampaignRes = await fwuCampaignsService.updateFWUCampaign(fwuCampaign);

      if (
        (notificationCampaignRes &&
          responseUtil.isResponseSuccessful(fwuCampaignRes) &&
          responseUtil.isResponseSuccessful(notificationCampaignRes)) ||
        (!notificationCampaignRes && responseUtil.isResponseSuccessful(fwuCampaignRes))
      ) {
        dispatch(pushCreatedTableRowsIds([fwuCampaign.campaign_name]));
        const incorrectDusns = handleIncorrectDusns(fwuCampaignRes, fwuCampaign.campaign_name);

        // After we receive response from the backend that request was completed, around 1 second passes
        // before newly created record will actually be added to the fwuCampaign list
        if (!incorrectDusns) {
          onSuccess(fwuCampaign);
        }

        setTimeout(() => {
          setLoading(false);
          dispatch(setFwuCampaingsRefresh(true));
        }, 1500);
      }
    } catch (err) {
      log.error("useUpdateFWUCampaign: Failed to update fwu campaign", err);

      setError(true);
      setLoading(false);

      notificationService.showError({
        title: t(strCode.UPDATE_FWU_CAMPAIGN_ERROR),
        message: err?.response?.data ? err.response.data : err?.toString()
      });
    }
  };

  return { mutationCallback, loading, error };
};
